export default "__VITE_ASSET__C3gk8seB__"